import React from 'react';

import { Typography } from '@mui/material';
import { PlainIconButton, Spacer } from 'src/components';
import { BackArrowIcon } from 'src/components/icons/BackArrowIcon';
import { useEditorTabStateActions } from 'src/editor/editor-tab-state-registry';
import { makeStyles } from 'tss-react/mui';

import { AddCommentForm } from './AddCommentForm';

const useStyles = makeStyles()(theme => ({
  backButton: {
    margin: theme.spacing(1.5, 0, 1.5, 2),
  },
  commentBar: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    height: 48,
  },
  panelContainer: {
    backgroundColor: theme.appColors.background,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  subtitle: {
    margin: theme.spacing(1.625, 2, 1.625, 2),
  },
  textAreaContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: theme.spacing(2),
  },
}));

export function AddCommentPanel(): JSX.Element | null {
  const { classes } = useStyles();
  const {
    comments: { setActivePanel },
  } = useEditorTabStateActions();

  return (
    <div className={classes.panelContainer}>
      <div className={classes.commentBar}>
        <PlainIconButton
          Icon={BackArrowIcon}
          className={classes.backButton}
          onClick={(): void => {
            setActivePanel('ViewComments');
          }}
        />
        <Typography className={classes.subtitle} variant="subtitle1">
          Add Comment
        </Typography>
      </div>
      <div className={classes.textAreaContainer}>
        <Spacer />
        <AddCommentForm />
      </div>
    </div>
  );
}
